import { svg } from '../api/svg'
import { Value } from './ast'
import { array } from './list';

function renderText(value: Value): string {
    switch (value.type) {
        case "drawing":
            return "✏️";
        case "number":
            return value.value.toString();
        case "symbol":
            return ":" + value.name;
        case "block":
            return "{}";
        case "label":
            return value.name;
        case "null":
            return "()";
        case "list":
            return "(" +
                array(value).map(renderText).join(", ")
                + ")"
        case "error":
            return "Error"
    }
}

function render(value: Value, width: number): string {
    switch (value.type) {
        case "drawing":
            console.log(width);
            var scaled = value.value;
            const maxDim =
                Math.max(scaled.bounds.width, scaled.bounds.height)
            if (maxDim > width) {
                scaled = scaled.scale((width - 40) / maxDim);
            }
            return svg(scaled)
        case "error":
            return `<span class="error">Error</span>`
        default:
            return renderText(value);
    }
}

export { render }